import {makeActionCreator} from '../utility'

export const FETCH_DISCIPLINE = 'FETCH_DISCIPLINE'
export const fetchDiscipline = makeActionCreator(FETCH_DISCIPLINE,'data')


export const FETCH_DISCIPLINE_SUCCESSFUL = 'FETCH_DISCIPLINE_SUCCESSFUL'
export const fetchDisciplineSuccessful = makeActionCreator(FETCH_DISCIPLINE_SUCCESSFUL, 'data')